<div #floatingFilterContainer
     *ngrxLet="viewModel$; let model;"
     class="relative"
     [matTooltip]="inputFormControl.value">
  <mat-form-field appearance="fill"
                  class="floatingFilter"
                  [ngClass]="{ 'activeFilter': model.hasValue }">
    <input matInput
           appGxInput
           [readonly]="model.readOnly"
           (click)="showParentFilter()"
           type="text"
           class="cursor-pointer"
           placeholder="{{ 'SELECT' | translate }}"
           [formControl]="inputFormControl"/>
    @if (!model.hasValue) {
      <mat-icon svgIcon="arrow_drop_down"
                class="cursor-pointer"
                matSuffix>
      </mat-icon>
    } @else {
      <button
          matSuffix
          mat-icon-button
          (click)="resetParentFilter()">
        <mat-icon svgIcon="close" class="closeIcon"></mat-icon>
      </button>
    }
  </mat-form-field>
  <!--  Add an overlay over the floating filter so that user can click anywhere to show the parent
        filter component except they click the Clear filter button (deduct icon size + 4px lp) -->
  <div class="absolute bottom-0 left-0 cursor-pointer z-[999]"
       (click)="showParentFilter()"
       [ngStyle]="{ width: floatingFilterContainer.offsetWidth - (model.hasValue ? 28 : 0) + 'px',
                    height: floatingFilterContainer.offsetHeight + 'px'}"></div>
</div>